import API from "../../routes/api.routes";
import { ApiMananger } from "../apiMananger";

const niveauApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getNiveaux: build.query({
      query: () => API.NIVEAUX_API.GETALL(),
      // query: () => API.NIVEAUX_API.GETALL,
      providesTags: ["Niveaux"],
    }),
    addNiveaux: build.mutation({
      query({ body, token }) {
        return {
          url: API.NIVEAUX_API.ADD(),
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body,
        };
      },
      invalidatesTags: ["Niveaux"],
    }),
    EditNiveaux: build.mutation({
      query({ body, token }) {
        return {
          url: API.NIVEAUX_API.EDIT(body?.id),
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body,
        };
      },
      invalidatesTags: ["Niveaux"],
    }),
    deleteNiveaux: build.mutation({
      query(id) {
        return {
          url: API.NIVEAUX_API.DELETE(id),
          method: "DELETE",
        };
      },
      invalidatesTags: ["Niveaux"],
    }),
  }),
});

export const {
  useGetNiveauxQuery,
  useAddNiveauxMutation,
  useEditNiveauxMutation,
  useDeleteNiveauxMutation,
} = niveauApi;
